var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 385.3 76.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .aa {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "logoMark"
  }, /*#__PURE__*/React.createElement("a", {
    xlinkHref: 38.4760784313725
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    "data-name": "logoMark PathItem ",
    className: "aa",
    d: "M46.27,34.06c-1.27,4.4-4.21,8.23-8.26,10.55-4.13,2.36-8.92,2.97-13.5,1.72-4.59-1.25-8.41-4.21-10.77-8.33-2.36-4.13-2.97-8.92-1.73-13.5,1.25-4.58,4.21-8.41,8.33-10.77,5.05-2.88,11.2-3.12,16.46-.63,2.84,1.35,6.24.13,7.58-2.7,1.34-2.84.13-6.23-2.71-7.58C33.06-1.27,22.97-.88,14.7,3.85,7.94,7.72,3.08,13.99,1.04,21.5-1.01,29.02,0,36.88,3.86,43.64c3.87,6.76,10.14,11.61,17.65,13.66,7.52,2.04,15.38,1.04,22.14-2.83,7.6-4.34,12.81-11.92,14.27-20.42h-11.65Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 38.4760784313725
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    "data-name": "logoMark PathItem -2",
    className: "aa",
    d: "M141.94,45.95c-5.94,2.07-12.6.84-17.39-3.23-3.62-3.07-5.83-7.37-6.23-12.11-.38-4.73,1.09-9.33,4.17-12.96,3.07-3.62,7.37-5.84,12.1-6.22,4.74-.39,9.34,1.09,12.97,4.16,4.43,3.76,6.75,9.47,6.2,15.26l-.02.27v21.88c0,3.14,2.54,5.69,5.69,5.69s5.69-2.55,5.69-5.69v-21.61l-.02.54c.9-9.5-2.91-18.84-10.17-25.01-5.94-5.04-13.49-7.46-21.25-6.82-7.77.64-14.82,4.26-19.85,10.21-5.04,5.94-7.47,13.48-6.83,21.25.64,7.76,4.26,14.81,10.21,19.85,7.85,6.66,18.77,8.69,28.5,5.29,2.97-1.04,4.53-4.28,3.49-7.25s-4.28-4.53-7.25-3.49h0Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 38.4760784313725
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    "data-name": "logoMark PathItem -3",
    className: "aa",
    d: "M90.65,34.23h0v17.71c0,3.14,2.55,5.69,5.69,5.69s5.69-2.54,5.69-5.69v-17.71h-11.38Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 38.4760784313725
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    "data-name": "logoMark PathItem -4",
    className: "aa",
    d: "M58.8,27c.06-5.59,3.11-10.61,7.95-13.38,3.66-2.09,7.92-2.64,11.99-1.53,4.07,1.11,7.46,3.74,9.55,7.4,1.32,2.31,2.04,4.93,2.08,7.56l11.38-.03c-.07-4.56-1.31-9.21-3.58-13.18-3.6-6.3-9.44-10.81-16.44-12.73-7-1.91-14.33-.98-20.62,2.63-8.33,4.76-13.57,13.69-13.68,23.29l11.39-.03s-.02,0-.02,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g",
    "data-name": "type"
  }, /*#__PURE__*/React.createElement("path", {
    id: "h",
    "data-name": "type CompoundPathItem ",
    className: "aa",
    d: "M211.24,46.26c-1.47.7-3.05.88-4.6,1.02l-4.51.4c-2.74.22-4.11.97-4.11,3.1s1.99,3.31,4.91,3.31c3.94,0,8.32-1.9,8.32-5.88v-1.95h0ZM191.2,41.35c.93-7.3,7.65-8.14,14.02-8.14,11.15,0,13.53,3.63,13.53,8.05v11.77c0,2.08.35,3.58.89,4.78h-7.78c-.27-.84-.49-1.68-.53-2.52-2.65,2.65-7.61,3.41-11.1,3.41-6.2,0-10.52-2.17-10.52-7.69s5.08-6.99,9.81-7.3l8.28-.58c2.39-.18,3.18-.57,3.18-2.48s-1.59-2.83-6.1-2.83c-3.32,0-5.04.27-6.14,3.54h-7.54,0Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    "data-name": "type PathItem ",
    className: "aa",
    points: "220.7 34.1 229.28 34.1 234.72 50.28 234.81 50.28 240.3 34.1 247.82 34.1 253.31 50.28 253.39 50.28 258.83 34.1 267.41 34.1 258.57 57.8 249.23 57.8 244.1 42.5 244.02 42.5 238.88 57.8 229.55 57.8 220.7 34.1 220.7 34.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    "data-name": "type CompoundPathItem -2",
    className: "aa",
    d: "M289.66,46.26c-1.46.7-3.05.88-4.6,1.02l-4.51.4c-2.75.22-4.12.97-4.12,3.1s1.99,3.31,4.91,3.31c3.94,0,8.31-1.9,8.31-5.88v-1.95h.01ZM269.63,41.35c.93-7.3,7.65-8.14,14.03-8.14,11.14,0,13.53,3.63,13.53,8.05v11.77c0,2.08.35,3.58.88,4.78h-7.78c-.27-.84-.49-1.68-.53-2.52-2.66,2.65-7.61,3.41-11.1,3.41-6.19,0-10.52-2.17-10.52-7.69s5.08-6.99,9.82-7.3l8.27-.58c2.39-.18,3.19-.57,3.19-2.48s-1.6-2.83-6.1-2.83c-3.32,0-5.04.27-6.15,3.54h-7.54Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "k",
    "data-name": "type PathItem -2",
    className: "aa",
    d: "M301.78,34.1h7.52v4.64h.09c2.84-3.63,5.05-5.27,9.47-5.27.89,0,1.95.04,2.83.22v7.29c-1.41-.39-2.83-.7-4.3-.7-5.3,0-7.83,2.7-7.83,7.29v10.22h-7.78v-23.71h0s0,.02,0,.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "l",
    "data-name": "type CompoundPathItem -3",
    className: "aa",
    d: "M338.49,52.94c3.9,0,7.3-2.35,7.3-6.86s-3.4-6.85-7.3-6.85-7.34,2.34-7.34,6.85,3.41,6.86,7.34,6.86h0ZM345.79,54.84h-.09c-2.52,3.06-5.84,3.85-9.37,3.85-7.39,0-13.23-4.2-13.23-12.47,0-7.7,5.75-12.74,13.23-12.74,4.38,0,7.6,1.41,9.1,3.54h.09v-11.31h7.79v32.1h-7.52v-2.97h0Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "m",
    "data-name": "type PathItem -3",
    className: "aa",
    d: "M365.3,50.46c.35,2.04,1.77,3.36,5.79,3.36,3.54,0,5.63-.84,5.63-2.57,0-1.33-.67-1.85-4.43-2.38l-7.08-.98c-4.95-.66-7.78-2.21-7.78-6.72,0-6.42,6.5-7.96,12.96-7.96,10.93,0,13.49,3.59,14.02,8h-8.58c-.44-2.43-3-3.14-5.26-3.14-2.04,0-5.09.18-5.09,2.52,0,1.1.58,1.86,3.93,2.2l5.4.58c7.92.84,10.49,3.19,10.49,7.3,0,7.03-7.87,8.01-14.65,8.01-8.98,0-13.53-2.61-13.93-8.23h8.58Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    "data-name": "type PathItem -4",
    className: "aa",
    d: "M199.15,11.66c-.02-1.06-1.01-1.8-2.09-1.8-2.39,0-2.77,1.94-2.77,3.67,0,1.61.73,3.26,2.55,3.26,1.48,0,2.24-.81,2.44-2.13h4.15c-.38,3.33-3.1,5.25-6.58,5.25-3.93,0-6.85-2.57-6.85-6.38s2.65-6.79,6.85-6.79c3.25,0,6.15,1.63,6.45,4.92h-4.16.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "o",
    "data-name": "type CompoundPathItem -4",
    className: "aa",
    d: "M211.46,16.79c1.99,0,2.62-1.87,2.62-3.46s-.63-3.48-2.62-3.48-2.59,1.89-2.59,3.48.61,3.46,2.59,3.46h0ZM211.46,6.74c4.06,0,6.9,2.85,6.9,6.59s-2.85,6.57-6.9,6.57-6.88-2.83-6.88-6.57,2.82-6.59,6.88-6.59h0Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "p",
    "data-name": "type PathItem -5",
    className: "aa",
    d: "M220.26,7.1h4.16v1.7h.05c.78-1.25,2.17-2.06,3.75-2.06s3.1.5,3.8,2.02c1.03-1.32,2.31-2.02,4.08-2.02,4.16,0,4.61,3,4.61,5.37v7.43h-4.28v-7.31c0-1.35-.67-2.14-1.79-2.14-1.84,0-2.02,1.34-2.02,3.36v6.09h-4.28v-7.07c0-1.46-.45-2.37-1.61-2.37-1.54,0-2.19.84-2.19,3.38v6.07h-4.28V7.1h0Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "q",
    "data-name": "type PathItem -6",
    className: "aa",
    d: "M243.31,7.1h4.15v1.7h.05c.78-1.25,2.17-2.06,3.76-2.06s3.1.5,3.8,2.02c1.03-1.32,2.32-2.02,4.08-2.02,4.16,0,4.61,3,4.61,5.37v7.43h-4.28v-7.31c0-1.35-.68-2.14-1.79-2.14-1.84,0-2.01,1.34-2.01,3.36v6.09h-4.28v-7.07c0-1.46-.45-2.37-1.61-2.37-1.54,0-2.19.84-2.19,3.38v6.07h-4.28V7.1h0Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    "data-name": "type PathItem -7",
    className: "aa",
    d: "M269.7,15.45c0,.62.28,1.08.7,1.39.4.29.98.43,1.59.43.83,0,2.01-.34,2.01-1.32s-1.33-1.15-2.09-1.32c-2.7-.65-6.07-.72-6.07-4.08,0-3,3.4-3.81,5.97-3.81,2.87,0,5.87.79,6.02,4.03h-3.95c0-.53-.2-.86-.56-1.08-.35-.22-.83-.31-1.36-.31-.71,0-1.84.07-1.84.93,0,1.18,2.87,1.39,4.83,1.8,2.65.5,3.33,2.33,3.33,3.36,0,3.33-3.33,4.43-6.27,4.43-3.1,0-6.27-.98-6.4-4.46h4.09Z"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    "data-name": "type PathItem -8",
    className: "aa",
    d: "M287.57,7.1h4.16v1.7h.05c.78-1.27,2.54-2.06,4.1-2.06,4.36,0,4.71,3.02,4.71,4.82v7.99h-4.28v-6.02c0-1.7.21-3.43-2.14-3.43-1.61,0-2.32,1.29-2.32,2.66v6.79h-4.28V7.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "t",
    "data-name": "type CompoundPathItem -5",
    className: "aa",
    d: "M308.52,17.39c2.04,0,2.72-1.1,2.62-3.67-.61.36-1.71.43-2.64.68-.96.21-1.77.6-1.77,1.58s.84,1.41,1.79,1.41h0ZM302.97,10.94c.08-1.63.88-2.69,2.04-3.33,1.16-.62,2.67-.87,4.16-.87,3.1,0,6.09.65,6.09,4.17v5.44c0,1.05,0,2.2.51,3.19h-4.31c-.15-.38-.2-.77-.25-1.17-1.11,1.1-2.75,1.54-4.31,1.54-2.49,0-4.46-1.2-4.46-3.77,0-4.05,4.64-3.74,7.61-4.31.73-.14,1.13-.38,1.13-1.15,0-.94-1.18-1.29-2.06-1.29-1.18,0-1.94.5-2.14,1.56h-4.01Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "u",
    "data-name": "type PathItem -9",
    className: "aa",
    d: "M325.53,9.74h-2.65v5.66c0,.98.61,1.2,1.54,1.2.35,0,.73-.05,1.11-.05v3c-.78.02-1.56.12-2.34.12-3.65,0-4.58-1.01-4.58-4.39v-5.54h-2.17v-2.64h2.17v-3.76h4.28v3.76h2.65v2.64s-.01,0-.01,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v",
    "data-name": "type CompoundPathItem -6",
    className: "aa",
    d: "M327.46,7.1h4.28v12.44h-4.28V7.1h0ZM331.74,5.54h-4.28v-3.12h4.28v3.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    "data-name": "type CompoundPathItem -7",
    className: "aa",
    d: "M340.58,16.79c1.99,0,2.62-1.87,2.62-3.46s-.63-3.48-2.62-3.48-2.59,1.89-2.59,3.48.61,3.46,2.59,3.46h0ZM340.58,6.74c4.06,0,6.9,2.85,6.9,6.59s-2.85,6.57-6.9,6.57-6.87-2.83-6.87-6.57,2.82-6.59,6.87-6.59h0Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("path", {
    id: "x",
    "data-name": "type PathItem -10",
    className: "aa",
    d: "M349.38,7.1h4.16v1.7h.05c.78-1.27,2.54-2.06,4.11-2.06,4.36,0,4.71,3.02,4.71,4.82v7.99h-4.28v-6.02c0-1.7.2-3.43-2.14-3.43-1.61,0-2.32,1.29-2.32,2.66v6.79h-4.28V7.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "y",
    "data-name": "type CompoundPathItem -8",
    className: "aa",
    d: "M370.33,17.39c2.04,0,2.72-1.1,2.62-3.67-.61.36-1.71.43-2.65.68-.96.21-1.76.6-1.76,1.58s.83,1.41,1.79,1.41h0ZM364.79,10.94c.08-1.63.88-2.69,2.04-3.33,1.16-.62,2.67-.87,4.16-.87,3.09,0,6.09.65,6.09,4.17v5.44c0,1.05,0,2.2.5,3.19h-4.3c-.15-.38-.21-.77-.25-1.17-1.11,1.1-2.75,1.54-4.31,1.54-2.49,0-4.46-1.2-4.46-3.77,0-4.05,4.64-3.74,7.6-4.31.73-.14,1.14-.38,1.14-1.15,0-.94-1.18-1.29-2.06-1.29-1.18,0-1.94.5-2.14,1.56h-4.01Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: 88.800431372549
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "z",
    "data-name": "type PathItem -11",
    className: "aa",
    points: "379.69 2.43 383.97 2.43 383.97 19.55 379.69 19.55 379.69 2.43 379.69 2.43"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M154.11,76.55h-2.25v-12.43h2.25v12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M165.19,70.05c-.25.44-.62.8-1.13,1.07-.51.27-1.14.41-1.9.41h-1.4v3.32h-2.25v-9.25h3.65c.74,0,1.36.13,1.87.38s.89.61,1.15,1.05c.25.45.38.96.38,1.54,0,.54-.12,1.02-.37,1.47h0ZM162.95,69.44c.21-.2.32-.49.32-.86s-.11-.65-.32-.86c-.21-.2-.53-.3-.96-.3h-1.22v2.32h1.22c.43,0,.75-.1.96-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M172.48,73.22h-3.45l-.55,1.63h-2.36l3.34-9.25h2.61l3.35,9.25h-2.38l-.55-1.63h0ZM171.9,71.48l-1.15-3.38-1.13,3.38h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M181.15,74.85l-1.92-3.49h-.54v3.49h-2.25v-9.25h3.78c.73,0,1.35.13,1.86.38s.9.6,1.15,1.05c.25.44.38.94.38,1.48,0,.62-.17,1.16-.52,1.65-.35.48-.86.83-1.53,1.03l2.13,3.66h-2.54ZM178.68,69.77h1.4c.41,0,.72-.1.93-.3.21-.2.31-.49.31-.86s-.1-.63-.31-.83c-.21-.2-.52-.3-.93-.3h-1.4v2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M190.38,74.85l-3.11-4.08v4.08h-2.25v-9.25h2.25v4.06l3.08-4.06h2.65l-3.58,4.53,3.71,4.71h-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M203.67,70.05c-.25.44-.62.8-1.13,1.07-.51.27-1.14.41-1.9.41h-1.4v3.32h-2.25v-9.25h3.65c.74,0,1.36.13,1.87.38s.89.61,1.15,1.05c.25.45.38.96.38,1.54,0,.54-.12,1.02-.37,1.47h0ZM201.43,69.44c.21-.2.32-.49.32-.86s-.11-.65-.32-.86-.53-.3-.96-.3h-1.22v2.32h1.22c.43,0,.75-.1.96-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M207.46,73.12h2.95v1.74h-5.2v-9.25h2.25v7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M217.25,73.22h-3.45l-.55,1.63h-2.36l3.34-9.25h2.61l3.35,9.25h-2.38l-.55-1.63h0ZM216.67,71.48l-1.15-3.38-1.13,3.38h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M223.59,73.01h3.98v1.84h-6.53v-1.71l3.95-5.69h-3.95v-1.84h6.53v1.71l-3.98,5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M234.8,73.22h-3.45l-.55,1.63h-2.36l3.34-9.25h2.61l3.35,9.25h-2.38l-.55-1.63h0ZM234.22,71.48l-1.15-3.38-1.13,3.38h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M249.55,65.61v9.25h-2.25v-3.81h-3.5v3.81h-2.25v-9.25h2.25v3.62h3.5v-3.62h2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M253.15,74.34c-.72-.4-1.3-.97-1.73-1.69s-.64-1.54-.64-2.44.21-1.72.64-2.44,1-1.28,1.73-1.69c.72-.4,1.52-.61,2.39-.61s1.67.2,2.39.61c.72.4,1.29.97,1.71,1.69.42.72.63,1.53.63,2.44s-.21,1.72-.63,2.44-.99,1.29-1.71,1.69-1.51.61-2.38.61-1.67-.2-2.39-.61h0ZM257.31,72.15c.44-.49.67-1.14.67-1.95s-.22-1.47-.67-1.96-1.03-.73-1.77-.73-1.34.24-1.79.72c-.44.48-.67,1.14-.67,1.96s.22,1.47.67,1.96,1.04.73,1.79.73,1.33-.25,1.77-.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M268.17,65.61v1.8h-2.45v7.44h-2.25v-7.44h-2.45v-1.8h7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M271.56,67.41v1.87h3.02v1.74h-3.02v2.03h3.41v1.8h-5.66v-9.25h5.66v1.8h-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M278.68,73.12h2.95v1.74h-5.2v-9.25h2.25v7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M285.14,72.77l-1.46,3.78h-1.44l.76-3.78h2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M302.01,65.61l-2.41,9.25h-2.73l-1.47-6.08-1.53,6.08h-2.73l-2.34-9.25h2.41l1.33,6.73,1.65-6.73h2.48l1.58,6.73,1.34-6.73h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M305.39,67.41v1.87h3.02v1.74h-3.02v2.03h3.41v1.8h-5.66v-9.25h5.66v1.8h-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M311.79,74.62c-.54-.22-.96-.54-1.28-.97s-.49-.95-.51-1.55h2.4c.04.34.15.6.36.78.2.18.46.27.79.27s.6-.08.79-.23.29-.37.29-.64c0-.23-.08-.42-.23-.57s-.34-.27-.57-.37-.54-.21-.96-.33c-.6-.18-1.08-.37-1.46-.55s-.7-.46-.97-.82-.41-.83-.41-1.41c0-.86.31-1.54.94-2.02.62-.49,1.44-.73,2.44-.73s1.84.24,2.46.73c.62.49.96,1.17,1,2.04h-2.44c-.02-.3-.13-.53-.33-.71-.2-.17-.46-.26-.78-.26-.27,0-.49.07-.66.22-.17.14-.25.35-.25.63,0,.3.14.53.42.7s.72.35,1.32.54c.6.2,1.08.4,1.46.58.37.18.7.45.97.8.27.35.41.8.41,1.36s-.13,1.01-.4,1.44-.66.77-1.17,1.03c-.51.25-1.11.38-1.8.38s-1.28-.11-1.82-.33h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M325.01,65.61v1.8h-2.45v7.44h-2.25v-7.44h-2.45v-1.8h7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M336.62,65.61v9.25h-2.25v-5.54l-2.07,5.54h-1.82l-2.08-5.56v5.56h-2.25v-9.25h2.66l2.59,6.4,2.57-6.4h2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M340.49,65.61v9.25h-2.25v-9.25h2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M350.39,74.85h-2.25l-3.77-5.7v5.7h-2.25v-9.25h2.25l3.77,5.73v-5.73h2.25v9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M353.55,74.62c-.54-.22-.96-.54-1.28-.97s-.49-.95-.51-1.55h2.4c.04.34.15.6.36.78.2.18.46.27.79.27s.6-.08.79-.23.29-.37.29-.64c0-.23-.08-.42-.23-.57s-.34-.27-.57-.37-.54-.21-.96-.33c-.6-.18-1.08-.37-1.46-.55s-.7-.46-.97-.82-.41-.83-.41-1.41c0-.86.31-1.54.94-2.02.62-.49,1.44-.73,2.44-.73s1.84.24,2.46.73c.62.49.96,1.17,1,2.04h-2.44c-.02-.3-.13-.53-.33-.71-.2-.17-.46-.26-.78-.26-.27,0-.49.07-.66.22-.17.14-.25.35-.25.63,0,.3.14.53.42.7s.72.35,1.32.54c.6.2,1.08.4,1.46.58.37.18.7.45.97.8.27.35.41.8.41,1.36s-.13,1.01-.4,1.44-.66.77-1.17,1.03c-.51.25-1.11.38-1.8.38s-1.28-.11-1.82-.33h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M366.78,65.61v1.8h-2.45v7.44h-2.25v-7.44h-2.45v-1.8h7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M370.16,67.41v1.87h3.02v1.74h-3.02v2.03h3.41v1.8h-5.66v-9.25h5.66v1.8h-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M379.75,74.85l-1.92-3.49h-.54v3.49h-2.25v-9.25h3.78c.73,0,1.35.13,1.86.38s.9.6,1.15,1.05.38.94.38,1.48c0,.62-.17,1.16-.52,1.65-.35.48-.86.83-1.53,1.03l2.13,3.66h-2.54,0ZM377.29,69.77h1.4c.41,0,.72-.1.93-.3.21-.2.31-.49.31-.86s-.1-.63-.31-.83c-.21-.2-.52-.3-.93-.3h-1.4v2.29Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M4.45,72.62c.85-.7,1.52-1.28,2.01-1.73.49-.45.9-.92,1.24-1.42.34-.49.51-.97.51-1.44,0-.35-.08-.63-.25-.83-.16-.2-.41-.3-.74-.3s-.59.12-.77.37c-.19.25-.28.6-.28,1.05h-2.15c.02-.74.18-1.35.47-1.85s.69-.86,1.18-1.09c.49-.23,1.03-.35,1.63-.35,1.03,0,1.81.26,2.33.79.52.53.79,1.22.79,2.07,0,.93-.32,1.79-.95,2.58s-1.44,1.57-2.42,2.32h3.51v1.81h-6.53v-1.65c.29-.23.43-.34.4-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M18.23,67.18h-4.06v1.79c.17-.19.42-.35.73-.47.31-.12.65-.18,1.01-.18.65,0,1.19.15,1.62.44.43.29.74.68.94,1.14.2.47.3.98.3,1.52,0,1.01-.29,1.82-.86,2.41-.57.59-1.38.89-2.42.89-.69,0-1.3-.12-1.81-.36s-.91-.57-1.18-.99c-.28-.42-.43-.92-.46-1.47h2.17c.05.27.18.49.38.67.2.18.47.27.82.27.41,0,.71-.13.91-.39.2-.26.3-.61.3-1.04s-.1-.75-.31-.97-.51-.34-.91-.34c-.29,0-.54.07-.73.21-.19.14-.32.33-.38.57h-2.15v-5.66h6.07v1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M26.79,65.6v1.78h-2.42v7.34h-2.22v-7.34h-2.42v-1.78h7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M35.81,65.6v9.13h-2.22v-3.76h-3.46v3.76h-2.22v-9.13h2.22v3.58h3.46v-3.58h2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M41.67,74.5c-.53-.22-.95-.54-1.27-.96-.32-.42-.48-.94-.5-1.53h2.37c.03.34.15.6.35.77.2.18.46.27.78.27s.59-.08.78-.23c.19-.15.29-.36.29-.63,0-.23-.08-.41-.23-.56-.15-.15-.34-.27-.56-.36-.22-.1-.54-.2-.94-.33-.59-.18-1.07-.36-1.44-.55-.37-.18-.69-.45-.96-.81-.27-.35-.4-.82-.4-1.39,0-.85.31-1.51.92-2,.62-.48,1.42-.72,2.4-.72s1.82.24,2.43.72c.62.48.94,1.15.99,2.01h-2.4c-.02-.29-.13-.53-.33-.7s-.46-.25-.77-.25c-.27,0-.49.07-.65.21-.16.14-.25.35-.25.62,0,.29.14.52.42.69.28.17.71.34,1.3.53.59.2,1.07.39,1.44.57.37.18.69.45.96.79.27.35.4.79.4,1.34s-.13.99-.4,1.42c-.26.42-.65.76-1.15,1.01-.5.25-1.1.38-1.78.38s-1.27-.11-1.79-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M50.38,67.39v1.85h2.98v1.72h-2.98v2h3.37v1.78h-5.59v-9.13h5.59v1.78h-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M61.78,69.99c-.24.44-.62.79-1.12,1.06-.5.27-1.13.4-1.87.4h-1.38v3.28h-2.22v-9.13h3.6c.73,0,1.34.13,1.85.38.5.25.88.6,1.13,1.04s.38.95.38,1.52c0,.53-.12,1.01-.36,1.45ZM59.57,69.39c.21-.2.31-.48.31-.85s-.1-.65-.31-.84-.52-.3-.95-.3h-1.21v2.29h1.21c.42,0,.74-.1.95-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M69.87,65.6v1.78h-2.42v7.34h-2.22v-7.34h-2.42v-1.78h7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M73.21,67.39v1.85h2.98v1.72h-2.98v2h3.37v1.78h-5.59v-9.13h5.59v1.78h-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M88.35,65.6v9.13h-2.22v-5.47l-2.04,5.47h-1.79l-2.05-5.49v5.49h-2.22v-9.13h2.63l2.56,6.32,2.53-6.32h2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M96.75,70.84c.32.41.48.88.48,1.41,0,.76-.27,1.37-.8,1.81-.53.45-1.28.67-2.23.67h-4.25v-9.13h4.11c.93,0,1.65.21,2.18.64.52.42.79,1,.79,1.73,0,.54-.14.98-.42,1.34-.28.36-.66.6-1.12.74.53.11.95.38,1.27.79ZM92.17,69.3h1.46c.36,0,.64-.08.84-.24.19-.16.29-.4.29-.71s-.1-.55-.29-.71c-.2-.17-.47-.25-.84-.25h-1.46v1.91ZM94.68,72.68c.2-.17.31-.41.31-.73s-.11-.57-.32-.75c-.21-.18-.5-.27-.88-.27h-1.61v2.01h1.64c.37,0,.66-.08.86-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M100.74,67.39v1.85h2.98v1.72h-2.98v2h3.37v1.78h-5.59v-9.13h5.59v1.78h-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M110.2,74.73l-1.9-3.45h-.53v3.45h-2.22v-9.13h3.73c.72,0,1.33.13,1.84.38.51.25.89.6,1.14,1.03.25.44.38.93.38,1.46,0,.61-.17,1.15-.51,1.62s-.85.81-1.51,1.01l2.11,3.61h-2.51ZM107.77,69.71h1.38c.41,0,.71-.1.92-.3.2-.2.31-.48.31-.84s-.1-.62-.31-.82c-.2-.2-.51-.3-.92-.3h-1.38v2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M116.89,72.62c.85-.7,1.52-1.28,2.01-1.73.49-.45.9-.92,1.24-1.42.34-.49.51-.97.51-1.44,0-.35-.08-.63-.25-.83-.16-.2-.41-.3-.74-.3s-.59.12-.77.37c-.19.25-.28.6-.28,1.05h-2.15c.02-.74.18-1.35.47-1.85s.69-.86,1.18-1.09c.49-.23,1.03-.35,1.63-.35,1.03,0,1.81.26,2.33.79.52.53.79,1.22.79,2.07,0,.93-.32,1.79-.95,2.58s-1.44,1.57-2.42,2.32h3.51v1.81h-6.53v-1.65c.29-.23.43-.34.4-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M124.85,66.33c.58-.86,1.51-1.29,2.79-1.29s2.21.43,2.79,1.29c.58.86.86,2.03.86,3.52s-.29,2.69-.86,3.55c-.58.86-1.51,1.29-2.79,1.29s-2.21-.43-2.79-1.29c-.58-.86-.86-2.04-.86-3.55s.29-2.67.86-3.52ZM128.82,67.83c-.19-.47-.58-.71-1.18-.71s-.99.24-1.18.71c-.19.47-.29,1.15-.29,2.02,0,.59.03,1.08.1,1.46s.21.7.42.94.53.36.94.36.73-.12.94-.36c.21-.24.35-.55.42-.94s.1-.87.1-1.46c0-.88-.1-1.55-.29-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M132.79,72.62c.85-.7,1.52-1.28,2.01-1.73.49-.45.9-.92,1.24-1.42.34-.49.51-.97.51-1.44,0-.35-.08-.63-.25-.83-.16-.2-.41-.3-.74-.3s-.59.12-.77.37c-.19.25-.28.6-.28,1.05h-2.15c.02-.74.18-1.35.47-1.85s.69-.86,1.18-1.09c.49-.23,1.03-.35,1.63-.35,1.03,0,1.81.26,2.33.79.52.53.79,1.22.79,2.07,0,.93-.32,1.79-.95,2.58s-1.44,1.57-2.42,2.32h3.51v1.81h-6.53v-1.65c.29-.23.43-.34.4-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M146.56,67.18h-4.06v1.79c.17-.19.42-.35.73-.47.31-.12.65-.18,1.01-.18.65,0,1.19.15,1.62.44.43.29.74.68.94,1.14.2.47.3.98.3,1.52,0,1.01-.29,1.82-.86,2.41-.57.59-1.38.89-2.42.89-.69,0-1.3-.12-1.81-.36s-.91-.57-1.18-.99c-.28-.42-.43-.92-.46-1.47h2.17c.05.27.18.49.38.67.2.18.47.27.82.27.41,0,.71-.13.91-.39.2-.26.3-.61.3-1.04s-.1-.75-.31-.97-.51-.34-.91-.34c-.29,0-.54.07-.73.21-.19.14-.32.33-.38.57h-2.15v-5.66h6.07v1.95Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.928b02b5d77b062f8bf8f515ac8049a9.svg";
export { ForwardRef as ReactComponent };